import styled from 'styled-components'

import { font } from 'services/Branding/common.styled'

const SkipToContentLinkStyled = styled.button<{ $font: React.CSSProperties }>`
  all: unset;
  height: 1px;
  clip-path: inset(50%);

  &:focus {
    ${({ $font }) => font($font)}
    clip-path: none;
    background: #000;
    color: #fff;
    padding: 8px 28px;
    height: auto;
  }
`

export default SkipToContentLinkStyled
